import React, { useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './navbar.module.css';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import logo from '../../assets/logo.png';

const menuItems = [
  { path: '/home', label: 'HOME' },
  {
    path: '/about',
    label: 'ABOUT',
    dropdown: [
      { path: '/about/advisory-committee', label: 'ADVISORY COMMITTEE' },
      { path: '/about/board-of-directors', label: 'BOARD OF DIRECTORS' },
      { path: '/about/history', label: 'History' },
      { path: '/about/projects', label: 'PROJECTS' },
      { path: '/about/facilities', label: 'OUR FACILITIES' },
      { path: '/about/what-we-do', label: 'WHAT WE DO' },
    ],
  },
  { path: '/gallery', label: 'GALLERY' },
  { path: '/award', label: 'AWARD' },
  { path: '/get-involved', label: 'GET INVOLVED' },
  { path: '/donate', label: 'DONATE' },
  { path: '/document', label: 'DOCUMENT' },
  { path: '/contact', label: 'CONTACT' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(true);
  const [desktopDropdownOpen, setDesktopDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const closeTimer = useRef(null);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
    setMobileDropdownOpen(false);
  };

  const openDesktopDropdown = () => {
    clearTimeout(closeTimer.current);
    setDesktopDropdownOpen(true);
  };
  const closeDesktopDropdown = () => {
    closeTimer.current = setTimeout(() => setDesktopDropdownOpen(false), 150);
  };

  const linkClass = ({ isActive }) =>
    isActive ? `${styles.active} ${styles.link}` : styles.link;

  const renderDesktopItem = (item, index, total) => {
    if (item.dropdown) {
      return (
        <React.Fragment key={item.path}>
          <div
            className={styles.dropdownWrapper}
            onMouseEnter={openDesktopDropdown}
            onMouseLeave={closeDesktopDropdown}
          >
            <NavLink to={item.path} className={linkClass}>
              {item.label} <FaChevronDown size="0.6rem" className={styles.chevron} />
            </NavLink>
            {desktopDropdownOpen && (
              <div className={styles.dropdownPanel}>
                {item.dropdown.map((sub) => (
                  <NavLink
                    key={sub.path}
                    to={sub.path}
                    className={linkClass}
                    onClick={() => setDesktopDropdownOpen(false)}
                  >
                    {sub.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          {index < total - 1 && <div className={styles.vetical_line} aria-hidden="true" />}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment key={item.path}>
        <NavLink to={item.path} className={linkClass}>
          {item.label}
        </NavLink>
        {index < total - 1 && <div className={styles.vetical_line} aria-hidden="true" />}
      </React.Fragment>
    );
  };

  const renderMobileItem = (item, index, total) => {
    if (item.dropdown) {
      return (
        <React.Fragment key={item.path}>
          <div className={styles.mobileDropdownGroup}>
            <button
              type="button"
              className={styles.link}
              onClick={() => setMobileDropdownOpen((prev) => !prev)}
              aria-expanded={mobileDropdownOpen}
            >
              {item.label}{' '}
              <FaChevronDown
                size="0.6rem"
                className={`${styles.chevron} ${mobileDropdownOpen ? styles.chevronOpen : ''}`}
              />
            </button>
            {mobileDropdownOpen && (
              <div className={styles.mobileDropdownPanel}>
                {item.dropdown.map((sub) => (
                  <NavLink
                    key={sub.path}
                    to={sub.path}
                    className={linkClass}
                    onClick={toggleMenu}
                  >
                    {sub.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          {index < total - 1 && <div className={styles.vetical_line} aria-hidden="true" />}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment key={item.path}>
        <NavLink to={item.path} onClick={toggleMenu} className={linkClass}>
          {item.label}
        </NavLink>
        {index < total - 1 && <div className={styles.vetical_line} aria-hidden="true" />}
      </React.Fragment>
    );
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarLogo}>
        <NavLink to="/home">
          <img src={logo} alt="Logo" className={styles.logo} loading="lazy" />
        </NavLink>
      </div>

      <div className={styles.hamburger}>
        {menuOpen ? (
          <FaBars onClick={toggleMenu} size="1.5rem" color="var(--nav-letter)" fontWeight="200" />
        ) : (
          <div className={styles.navbarMenuOpen}>
            <div>
              <FaTimes onClick={toggleMenu} size="1.5rem" color="var(--nav-letter)" fontWeight="200" />
            </div>
            {menuItems.map((item, index) => renderMobileItem(item, index, menuItems.length))}
          </div>
        )}
      </div>

      <div className={styles.navbarMenu} role="navigation" aria-label="Main menu">
        {menuItems.map((item, index) => renderDesktopItem(item, index, menuItems.length))}
      </div>
    </nav>
  );
};

export default Navbar;